export const BASE_MASK = {
  /** A mask can be of type Number, where input value must be numerical */
  isNumber: false,
  /** Whether the unmasked value in the state, will be re-masked when mapped to form payload. */
  maskOnSubmit: true,
  /** A non-typed mask should have a pattern to mask against. */
  pattern: '',
  /** Any additional props for the input mask */
  additionalProps: {}
}

export const NUMERICAL_MASK = { isNumber: true }
export const DATE_MASK_OPTIONS = { ...BASE_MASK, pattern: '00/00/0000' }
export const TELEPHONE_MASK_OPTIONS = { ...BASE_MASK, pattern: '(000)000 - 0000' }
export const MEDICATION_DATE_RANGE_MASK_OPTIONS = { ...BASE_MASK, pattern: '00/00/0000  -  00/00/0000' }
export const SSN_MASK_OPTIONS = { ...BASE_MASK, pattern: '000-00-0000' }
export const CURRENCY_MASK_OPTIONS = {
  ...BASE_MASK,
  isNumber: true,
  maskOnSubmit: true,
  additionalProps: {
    thousandsSeparator: ',',
    radix: '.',
    normalizeZeros: false,
    scale: 2,
    signed: true,
    padFractionalZeros: false
  }
}
